<template>
  <div v-if="showDashboardBtn" class="full-screen-btn-con">
    <Tooltip content="数字驾驶舱" placement="bottom">
      <Icon @click.native="handleChange" type="ios-speedometer" :size="23"></Icon>
    </Tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  computed: {
    ...mapGetters({
      agent: 'agent'
    }),
    showDashboardBtn () {
      return this.agent && !this.agent.tp
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange () {
      // 使用Vue路由在新窗口打开/dashboard页面
      const routeData = this.$router.resolve({ path: '/dashboard' })
      window.open(routeData.href, '_blank')
    }
  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
.full-screen-btn-con .ivu-tooltip-rel {
  height: 64px;
  line-height: 64px;
  padding-top: 5px;

  i {
    cursor: pointer;
  }
}
</style>
